import React from 'react';
import { Body, CardBase, Divider, Label, List, ListItem, Title } from '@icarros/ids-react';
import { CardBaseModifier, CardBody, CardHeader, ListItemModifier, MessageWrapper } from './style';

import { formatToDate } from '../../../utils/formatters';
import { useProposalsContext } from '../../../store/contexts/proposals';

export function Message(): JSX.Element {
  const { currentProposal } = useProposalsContext();
  const { compradorEmail, compradorMensagem, compradorNome, compradorTelefone, data } =
    currentProposal || {};

  const phoneNumber = Number(
    compradorTelefone ? compradorTelefone.trim().replaceAll(' ', '') : undefined
  );

  function handleEmailClick() {
    window.open('mailto:' + compradorEmail);
  }

  function handlePhoneClick() {
    window.open('tel:' + phoneNumber);
  }

  return (
    <MessageWrapper>
      <Title size="overline">mensagem recebida de</Title>
      <Title>{compradorNome}</Title>
      <List>
        <ListItemModifier isSingle>
          <ListItem
            label={compradorEmail ?? ''}
            subLabel={isNaN(phoneNumber) ? '' : compradorTelefone}
          />
        </ListItemModifier>
      </List>
      <CardBaseModifier>
        <CardBase variant="default" hasHover={false} selected={false}>
          <CardHeader>
            <Label variant="neutral" size="xsmall">
              {formatToDate(data ? data : 0, 'medium')}
            </Label>
            <Divider contrast="default" size="soft" variant="neutral" weight="light" />
          </CardHeader>
          <CardBody>
            <Body size="body_2">{compradorMensagem}</Body>
          </CardBody>
          <List>
            <ListItemModifier hideNextSiblingOnDesk>
              <ListItem
                avatarIcon="itaufonts_email_resp_rapida"
                avatarVariant="icon"
                label="enviar email"
                variant="action"
                actionOnClick={() => handleEmailClick()}
              />
            </ListItemModifier>
            {!isNaN(phoneNumber) ? (
              <ListItemModifier>
                <ListItem
                  avatarIcon="itaufonts_telefone"
                  avatarVariant="icon"
                  label="telefonar"
                  variant="action"
                  actionOnClick={() => handlePhoneClick()}
                />
              </ListItemModifier>
            ) : (
              <></>
            )}
          </List>
        </CardBase>
      </CardBaseModifier>
    </MessageWrapper>
  );
}
